// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2Tus_","content":"styles_content__2MlFQ","popup":"styles_popup__mJpon"};